import regulatoryTopicOverviews, { sarOverviewAdditions, recordKeepingOverviewAdditions, riskOverviewAdditions, periodicReviewOverviewAdditions, sowSofOverviewAdditions } from "../../regulations/topics/regulatoryTopicOverviews";
import "./RegulatoryTopicOverview.css";

const sourceLabels = {
  "federal-decree-law-10-2025": "AML Decree-Law",
  "cabinet-resolution-134-2025": "AML Implementing Resolution",
  "cabinet-decision-74-2020": "Sanctions and Freezing Decision",
  "fi-aml-cft-guidelines-2021": "FI AML Guidelines",
  "dnfbp-aml-cft-guidelines-2021": "DNFBP AML Guidelines",
  "dfsa-aml-module": "DFSA AML Rulebook",
  "fsra-aml-rulebook": "FSRA AML Rulebook",
};

export function hasRegulatoryTopicOverview(topic, country) {
  return Boolean(regulatoryTopicOverviews[topic?.id] && !topic.isSearchTopic && country === "uae" && topic.documents?.length);
}

export default function RegulatoryTopicOverview({ topic, country, regime, entityType }) {
  if (!hasRegulatoryTopicOverview(topic, country)) return null;
  const overview = regulatoryTopicOverviews[topic.id];

  const documentIds = new Set(topic.documents.map((document) => document.documentId));
  const guidelineLabel = documentIds.has("dnfbp-aml-cft-guidelines-2021") ? "DNFBP AML Guidelines" : "FI AML Guidelines";
  const additions = [];
  if (topic.id === "sow-sof") {
    if (regime === "dfsa" && documentIds.has("dfsa-aml-module")) additions.push(sowSofOverviewAdditions.difc);
    if (regime === "fsra" && documentIds.has("fsra-aml-rulebook")) additions.push(sowSofOverviewAdditions.adgm);
  }
  if (topic.id === "periodic-review") {
    if (regime === "dfsa" && documentIds.has("dfsa-aml-module")) additions.push(periodicReviewOverviewAdditions.difc);
    if (regime === "fsra" && documentIds.has("fsra-aml-rulebook")) additions.push(periodicReviewOverviewAdditions.adgm);
  }
  const riskAdditions = riskOverviewAdditions[topic.id];
  if (riskAdditions) {
    if (regime === "dfsa" && documentIds.has("dfsa-aml-module")) additions.push(riskAdditions.difc);
    if (regime === "fsra" && documentIds.has("fsra-aml-rulebook")) additions.push(riskAdditions.adgm);
  }
  if (topic.id === "sars") {
    if (entityType === "dnfbp" && documentIds.has("dnfbp-aml-cft-guidelines-2021")) {
      additions.push(sarOverviewAdditions.dnfbp);
    }
    if (regime === "dfsa" && documentIds.has("dfsa-aml-module")) {
      additions.push(sarOverviewAdditions.difc);
    }
  }
  if (topic.id === "record-keeping") {
    if (regime === "dfsa" && documentIds.has("dfsa-aml-module")) {
      additions.push(recordKeepingOverviewAdditions.difc);
    }
    if (regime === "fsra" && documentIds.has("fsra-aml-rulebook")) {
      additions.push(recordKeepingOverviewAdditions.adgm);
    }
  }

  return (
    <section className="regulatoryTopicOverviewView" aria-labelledby="regulatory-overview-title">
      <header className="regulatoryReaderChapterHeader regulatoryTopicParentPath">
        <p className="regulatoryReaderChapterLabel">Regulatory overview</p>
        <h3 id="regulatory-overview-title">{overview.title}</h3>
      </header>
      <div className="regulatoryTopicOverview">
        <div className="regulatoryTopicOverviewGrid">
          {overview.sections.map((section) => (
            <div className="regulatoryTopicOverviewSection" key={section.title}>
              <h4>{section.title}</h4>
              <div className="regulatoryTopicOverviewSectionCard">
                {section.paragraphs?.map((paragraph) => (
                  <p key={paragraph}>{paragraph.replace("The applicable AML Guidelines", `The ${guidelineLabel}`)}</p>
                ))}
                {section.points?.length > 0 && (
                  <ul>{section.points.map((point) => (
                    <li key={point}>{point.replace("The applicable AML Guidelines", `The ${guidelineLabel}`)}</li>
                  ))}</ul>
                )}
              </div>
            </div>
          ))}
        </div>
        {additions.length > 0 && (
          <div className="regulatoryTopicOverviewAdditions">
            {additions.map((addition) => (
              <div key={addition.title}>
                <h4>{addition.title}</h4>
                <div className="regulatoryTopicOverviewSectionCard">
                  {addition.text && <p>{addition.text}</p>}
                  {addition.points?.length > 0 && (
                    <ul>{addition.points.map((point) => <li key={point}>{point}</li>)}</ul>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
        <p className="regulatoryTopicOverviewSources">
          <strong>References:</strong> {[...documentIds].map((id) => sourceLabels[id]).filter(Boolean).join(" · ")}
        </p>
      </div>
    </section>
  );
}
